<div class="card">
  @if (tilvalg.length === 0) {
    <button class="btn-icon blue btn-add-small" type="button" [routerLink]="['/tilvalg/edit', serviceaftale.id]">
      <mat-icon svgIcon="add-small"></mat-icon>
      Tilføj tilvalg
    </button>
  }
  @if (tilvalg.length > 0) {
    <div class="detail-rows detail-rows--transparent hidden-btn-edit">
      @for (valg of tilvalg; track valg) {
        <div class="detail-row">
          <div class="detail-row__lbl bold">Tilvalg</div>
          <div class="detail-row__val">{{ valg.name }}</div>
        </div>
      }
      <div class="detail-rows__edit">
        @if (!isServiceaftaleTerminatedOrHasPendingTermination()) {
          <button
            [disabled]="!hasRights"
            type="button"
            class="btn-icon btn-blue-edit"
            (click)="editTilvalg()"
            matTooltip="Rediger tilvalg"
            >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        }
      </div>
    </div>
  }
  @if (isServiceaftaleTerminatedOrHasPendingTermination() && canServiceaftaleBeReactivated()) {
    <div class="tiny-text">
      Fortryd først opsigelse af aftalen, hvis du vil ændre på abonnement og/eller tilvalg
    </div>
  }
</div>
